import {useSettingsStore} from "@/store/settings";

export function useUserSettings() {
    const settingsStore = useSettingsStore();

    return {
        ...settingsStore.user
    }
}
